import { createSelector } from "reselect";
import { AppState } from "../appState";
import { IUserPermissions } from "../../models";

const userPermissionsSelector = (state: AppState) => state.userPermissions as unknown as (IUserPermissions | Record<string, any> | undefined);

const hasAnyEnabledFor = (node: unknown): boolean => {
  if (typeof node === "boolean") return node;

  const enabledFor = (node as any)?.enabledFor;
  if (Array.isArray(enabledFor)) return enabledFor.length > 0;

  return false;
};

/**
 * These selectors must return booleans (used by ProtectedRoute and other UI conditionals).
 * Backward-compat: some tests still seed legacy boolean keys (e.g. userPermissions.onHandDelivery).
 */
export const hasOveragesPermissionSelector = createSelector(
  [userPermissionsSelector],
  (permissions) => hasAnyEnabledFor((permissions as any)?.overages)
);

export const hasShortagesPermissionSelector = createSelector(
  [userPermissionsSelector],
  (permissions) => hasAnyEnabledFor((permissions as any)?.shortages)
);

export const hasDamagesPermissionSelector = createSelector(
  [userPermissionsSelector],
  (permissions) => hasAnyEnabledFor((permissions as any)?.damages)
);

export const hasOnHandDeliveryPermissionSelector = createSelector(
  [userPermissionsSelector],
  (permissions) =>
    hasAnyEnabledFor((permissions as any)?.onHandDeliveries)
);

export const hasMisdeliveryPermissionSelector = createSelector(
  [userPermissionsSelector],
  (permissions) =>
    hasAnyEnabledFor((permissions as any)?.misDeliveries)
);

export const hasCompleteMisdeliveryPermissionSelector = createSelector(
  [userPermissionsSelector],
  (permissions) => (permissions as any)?.misDeliveries?.investigationAndFollowUp?.completion?.enabledFor ?? []
);

export const hasMisdeliveryInvestigationPermissionSelector = createSelector(
  [userPermissionsSelector],
  (permissions) =>  (permissions as any)?.misDeliveries?.investigationAndFollowUp?.enabledFor ?? []
);

export const hasMisdeliveryHazmatApprovalPermissionSelector = createSelector(
  [userPermissionsSelector],
  (permissions) =>
    hasAnyEnabledFor((permissions as any)?.misDeliveries?.bol?.hazmatApproval)
);

export const hasCompleteShortagesPermissionSelector = createSelector(
  [userPermissionsSelector],
  (permissions) =>
    hasAnyEnabledFor(
      (permissions as any)?.shortages?.investigationAndFollowUp?.completion
    )
);

export const hasCompleteOnHandPermissionSelector = createSelector(
  [userPermissionsSelector],
  (permissions) =>
    hasAnyEnabledFor(
      (permissions as any)?.onHandDeliveries?.investigationAndFollowUp?.completion
    )
);

export const hasOhInvestigationSelector = createSelector(
  [userPermissionsSelector],
  (permissions) =>
    hasAnyEnabledFor((permissions as any)?.onHandDeliveries?.investigationAndFollowUp)
);
